import { createSlice } from '@reduxjs/toolkit';

const THEME_KEY = 'edc.theme';
const stored = localStorage.getItem(THEME_KEY);
const prefersDark = typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
const initial = stored || (prefersDark ? 'dark' : 'light');

if (typeof document !== 'undefined') {
  document.documentElement.classList.toggle('dark', initial === 'dark');
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: { mode: initial },
  reducers: {
    toggleTheme(state) {
      state.mode = state.mode === 'dark' ? 'light' : 'dark';
      localStorage.setItem(THEME_KEY, state.mode);
      document.documentElement.classList.toggle('dark', state.mode === 'dark');
    },
    setTheme(state, action) {
      state.mode = action.payload;
      localStorage.setItem(THEME_KEY, state.mode);
      document.documentElement.classList.toggle('dark', state.mode === 'dark');
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
